import type { AppConfig } from '../src/types/types';

export const APP_CONFIG_DEFAULTS: AppConfig = {
  supportsChatInput: true,
  supportsVideoInput: false,
  supportsScreenShare: true,
  isPreConnectBufferEnabled: true,
  startButtonText: 'Start call',

  // Add these critical properties:
  liveKitUrl: import.meta.env.VITE_LIVEKIT_URL || 'wss://sample-xqptfgyp.livekit.cloud',
  backendUrl: import.meta.env.VITE_API_BASE_URL || 'https://0b3af679ac19.ngrok-free.app', // Centralized backend URL
  sandboxId: '', // Optional, can be empty string

  agentName: undefined,
};